import type { SyntheticEvent } from "react";

// MUI grid drops must not reach react-dnd's backend: https://github.com/react-dnd/react-dnd/issues/3491.
export const stopEventPropagation = (event: SyntheticEvent): void => {
  event.stopPropagation();
};
